import React from 'react';
import { useRouteMatch, Switch, Route } from 'react-router-dom';
import PageMenu from 'components/PageMenu';
import { ReactComponent as PlusIcon } from 'assets/heroicons/icon-plus.svg';
import Organisation, {
  NoOrganisation,
} from 'components/Admin/orgs/Organisation';
import FloatingActionButton from 'components/FloatingActionButton/FloatingActionButton';
import { useGetOrganisationsQuery } from './queries/GetOrganisations.generated';
import { useNavigate } from 'routeMap';
import Bugsnag from '@bugsnag/js';

const Organisations = () => {
  const { path, url } = useRouteMatch();
  const navigate = useNavigate();
  const [result] = useGetOrganisationsQuery();
  if (result?.error) Bugsnag.notify(result?.error);

  const organisations = result.data?.organisations;

  return (
    <div className="relative flex flex-col w-full md:flex-row">
      <PageMenu
        base={url}
        items={organisations?.map((organisation) => ({
          to: `${url}/${organisation?.id}`,
          label: organisation?.name ?? 'Name missing',
          // icon: OfficeIcon,
        }))}
      />
      <FloatingActionButton Icon={PlusIcon} onClick={() => navigate.newOrg()} />

      <Switch>
        <Route exact path={`${path}/`}>
          <NoOrganisation />
        </Route>
        {organisations?.map((organisation) => (
          <Route path={`${path}/${organisation?.id}`} key={organisation?.id}>
            <Organisation id={organisation.id} />
          </Route>
        ))}
        <Route path={`${path}/new`}>
          <Organisation id={null} />
        </Route>
      </Switch>
    </div>
  );
};

export default Organisations;
